import {Link} from 'react-router-dom'
import './FactsGrid.css'
import Immutable from 'immutable'
import React, {Component, Fragment} from 'react'

const footerStyle = {
  gridColumnStart: 2,
  gridColumnEnd: 'end'
}

const preFlipDelay = 2500
const postFlipDelay = 1000
const flipInterval = 100
const postGameDelay = 1000

const emojis = [
  '😎','🤩','🤓','🤖','👽','👾','😺','👍',
  '🐶','🐱','🐨','🐸','🐷','🐵','🐧','🍀',
  '🥇','🏆','🏅','🎨','🎧','🎉','🎈','🕶',
  '🐞','🦄','🦋','🐛','🦕','🦖','🐬','🐳',
  '🐉','🦒','💐','🌸','🌻','🌈','🌛','🍎',
  '🥑','🍌','🍕','🍭','🍰','🍪','🍩','🍫',
  '⚽️','🏀','🏈','⚾️','🎾','🏐','🏉','🏒',
  '🥁','🎮','🏵','🎸','🚀','🏰','🛸','🌋'
]
const randomEmoji = () => emojis[parseInt(Math.random()*emojis.length)]

const op = (subject, a, b) => (subject == 'add') ? (a + b) : (a * b)

class FactsGrid extends Component {
  constructor(props) {
    super(props)

    this.state = {
      flipCount: 0,
      started: false,
      done: false,
      current: null,
      input: '',
      activeRow: 0,
      activeCol: 0,
      lockCol: 0,
      lockRow: 0,
      wrongRow: 0,
      wrongCol: 0,
      prevRow: 0,
      prevCol: 0,
      grid: this.initialGrid()
    }
  }

  initialGrid() {
    let r = Immutable.Range(1, this.props.size + 1);

    return r.reduce((m, y) =>
      m.set(
        y,
        r.reduce((m2, x) => m2.set(x, Immutable.fromJS({
          x, y,
          answer: op(this.props.subject, x, y),
          done: false
        })), Immutable.Map({}))
      ),
      Immutable.Map({})
    )
  }

  componentDidMount() {
    this.pregame()
  }

  pregame() {
    setTimeout(() => {
      this.interval = setInterval(() => {
        this.setState({flipCount: this.state.flipCount + 1})
        // console.log('flipCount', this.state.flipCount)
        if (this.state.flipCount > (2 * this.props.size + 1)) {
          clearInterval(this.interval)
          setTimeout(
            () => {this.startGame()},
            postFlipDelay
          )
        }
      }, flipInterval)
    }, preFlipDelay)
  }

  postgame() {
    this.setState({
      activeRow: 0,
      activeCol: 0,
      lockCol: 0,
      lockRow: 0,
      wrongRow: 0,
      wrongCol: 0,
      done: true
    })
    setTimeout(() => {
      this.interval = setInterval(() => {
        this.setState({
          flipCount: this.state.flipCount - 1
        })
        if (this.state.flipCount < 100000) {
          this.setState({
            flipCount: 0
          })
        }
      }, 500)
    }, postGameDelay)
  }

  startGame() {
    this.setState({
      started: true
    })
    this.showNext()

    gtag('event', 'start-game')
  }

  setActive(r, c) {
    let s = {
      activeRow: r,
      activeCol: c,
      input: ''
    }
    if (this.state.activeRow || this.state.activeCol) {
      s.prevRow = this.state.activeRow,
      s.prevCol = this.state.activeCol
    }

    this.setState(s)

    if (this.input) {
      this.input.focus();
    }
  }

  lockRowCol(r, c) {
    if (
      (this.state.lockRow && (this.state.lockRow == r)) ||
      (this.state.lockCol && (this.state.lockCol == c))
    ) {
      this.setState({
        lockRow: 0,
        lockCol: 0,
      })
    }
    else {
      this.setState({
        lockRow: r,
        lockCol: c,
      })


      // Reset row/col if already finished
      if (r || c) {
        let allDoneRowCol = this.state.grid
          .reduce(
            (list, gridRow) => list.concat(gridRow), Immutable.List([])
          )
          .filter(cell => (
            (r && (cell.get('y') == r)) ||
            (c && (cell.get('x') == c))
          ))
          .every(cell => (cell.get('done')))

        if (allDoneRowCol) {
          this.setState({
            grid: this.state.grid
              .map((row, x_1) => row
                .map((cell, y_1) => {
                  if ((r && (r == (x_1))) || (c && (c == (y_1)))) {
                    return cell.set('done', false)
                  }
                  return cell
                }
              )
            )
          })
          gtag('event', 'complete-row-column', {
            op: this.props.subject,
            size: this.props.size,
            row: r,
            col: c
          })
        }
        else {
          gtag('event', 'lock-row-column', {
            op: this.props.subject,
            size: this.props.size,
            row: r,
            col: c
          })
        }
      }
    }
    setTimeout(() => {
      this.showNext()
    }, 10)
  }

  showNext() {
    // let allCards =
    // console.log('grid:')
    // console.log(this.state.grid.toJS())
    const {prevRow, prevCol} = this.state;
    // console.log('showNext', this.state.activeRow, this.state.activeCol, this.state.prevRow, this.state.prevCol)

    const flatListRemaining =
      this.state.grid.reduce(
        (list, gridRow) => list.concat(gridRow),
        Immutable.List([])
      )
      .filter(c => (!c.get('done')))
      .filter(c => {
        if (this.state.lockRow) {
          return c.get('y') == this.state.lockRow
        }
        else if (this.state.lockCol) {
          return c.get('x') == this.state.lockCol
        }
        return true
      })
      .sortBy(c =>
        c.get('x') + c.get('y') +
        (((c.get('x') == prevCol) && (c.get('y')) == prevRow) ? 100 : 0)
      )
      // TODO: have sort avoid recent flips
    // console.log(flatListRemaining.map(c => `${c.get('y')},${c.get('x')}`).join('__'))

    let done = false

    if (flatListRemaining.size) {
      const frs = flatListRemaining.size
      // Choose from the lower numbers (at least early on)...
      // Always avoid the previous one if possible...
      // Account for locked row/col
      const s = (this.state.lockRow || this.state.lockCol) ?
        this.props.size :
        this.props.size * this.props.size
      let slice = (frs < s/2) ? s : Math.floor(s/2)

      slice = Math.max(1, Math.min(slice, frs))

      if (slice > 1 && (this.state.wrongCol || this.state.wrongRow)) {
        // console.log('dec slice', slice)
        slice--
      }

      let ix = parseInt(Math.random() * slice)
      const n = flatListRemaining.get(ix)
      if (!n) {
        console.error('something went wrong')
      }
      const next = n.toJS()
      this.setActive(next.y, next.x)
    }
    else if ((this.state.lockRow || this.state.lockCol)) {
      this.lockRowCol(0, 0);
      return
    }
    else {
      gtag('event', 'finish-game', {
        op: this.props.subject,
        size: this.props.size
      })
      this.postgame()
    }
  }

  submit() {
    const r = this.state.activeRow
    const c = this.state.activeCol
    const active = this.state.activeRow && this.state.activeCol && this.state.grid.getIn([r, c])

    if (!active) {
      return
    }

    const answer = active && active.get('answer')

    if (parseInt(this.input.value) == answer) {
      // console.log('✅', answer)

      this.setState({
        activeRow: 0,
        activeCol: 0,
        prevRow: r,
        prevCol: c,
        input: '',
        grid: this.state.grid.setIn([r, c, 'done'], true),
        wrongCol: 0,
        wrongRow: 0
      })
    }
    else {
      // console.log(`❌ [${this.input.value}] !== [${answer}]`,)
      this.setState({
        activeRow: 0,
        activeCol: 0,
        prevRow: r,
        prevCol: c,
        input: '',
        wrongRow: r,
        wrongCol: c
      });
    }
    setTimeout(() => {
      this.showNext()
    }, 10)
  }

  reset() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.setState({
      done: false,
      started: false,
      grid: this.initialGrid()
    })
    this.pregame()
  }

  changeInput(ev) {
    this.setState({
      input: ev.target.value
    })
  }

  renderCell(r, c, ix) {
    const allDone = this.state.done;
    const active = !allDone && (this.state.activeRow == r) && (this.state.activeCol == c)
    const done = this.state.grid.getIn([r, c, 'done'])
    const wrong = (this.state.wrongRow == r) && (this.state.wrongCol == c)
    const flipped = !wrong && (active || (
      (((r + c) <= this.state.flipCount) && !done) ||
      (((r + c) >= this.state.flipCount) && allDone)
    ))

    const notLocked =
      (this.state.lockRow && (r !== this.state.lockRow)) ||
      (this.state.lockCol && (c !== this.state.lockCol))

    const back = this.state.done ? randomEmoji() : '?'

    // const flipped = this.state.grid.getIn([r * this.props.size + c, 'done'], false)
    return (
      <div
        key={ix}
        className={'grid-cell card' +
          (flipped ? ' flipped' : '') +
          (active ? ' active' : '') +
          (done ? ' done' : '') +
          (notLocked ? ' notLocked': '') +
          (wrong ? ' wrong': '')
        }
        onClick={() => this.setActive(r, c)}
      >
        <figure className="front">{op(this.props.subject, r, c)}</figure>
        <figure className="back">{ back }</figure>
      </div>
    )
  }

  renderFooter() {
    const inputValue = this.state.input
    const opSymbol = this.props.subject == 'add' ? '+' : '×'

    if (!this.state.started) {
      return (
        <div className="grid-footer" style={footerStyle} >
          <span>Get Ready...</span>
        </div>
      )
    }
    else if (this.state.done) {
      return (
        <div className="grid-footer" style={footerStyle} >
          <span className="button" onClick={this.reset.bind(this)}>Again ?</span>
        </div>
      )
    }
    else {
      const r = this.state.activeRow
      const c = this.state.activeCol
      const active = this.state.activeRow && this.state.activeCol && this.state.grid.getIn([r, c])
      const placeholder = active && `${active.get('y')} ${opSymbol} ${active.get('x')}` || ''
      return (
        <div
          className="grid-footer"
          style={footerStyle}
        >
          <form onSubmit={ev => {
            ev.preventDefault()
            ev.stopPropagation()
            this.submit()
          }} >
            <input
              key="inputKey"
              // type="tel" pattern="[0-9]*" novalidate
              placeholder={placeholder}
              ref={ref => this.input = ref}
              type="number"
              value={inputValue}
              onChange={this.changeInput.bind(this)}
              onKeyUp={
                ({which}) => {
                  // console.log('key', which);
                  // (which == 13) && this.submit()
                }
              }
            />
          </form>
        </div>
      )
    }
  }

  render() {
    let { size } = this.props
    return (
      <div
        className={'App-main facts-grid' + (this.state.done ? ' finished' : '')}
      >
        <div
          className="grid"
          style={{
            gridTemplateColumns: `${Array(size + 1).fill('1fr').join(' ')} [end]`,
            gridTemplateRows: `${Array(size + 1).fill('1fr').join(' ')} 2fr`,
          }}
        >
          {Immutable.Range(0, (size + 1) * (size + 1)).map((n, ix) => {
            // +1's above are for header row and column (not Range off-by-one)
            let r = parseInt(n/(size + 1)) || 0;
            let c = n % (size + 1);
            if (!r && !c) {
              return (
                <div key={ix} />
              )
            }
            else if (!r) {
              return (
                <div
                  key={ix}
                  className="grid-header"
                  onClick={() => {this.lockRowCol(r, c)}}
                ><span>{c}</span>
                </div>
              )
            }
            else if (!c) {
              return (
                <div
                  key={ix}
                  className="grid-header"
                  onClick={() => {this.lockRowCol(r, c)}}
                ><span>{r}</span>
                </div>
              )
            }
            else {
              return this.renderCell(r, c, ix)
            }})
          }
          {this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default FactsGrid



// WEBPACK FOOTER //
// ./src/FactsGrid.js